/* Hippy Chick Ibiza - isolated global desktop header repair
   Fixes only ticker, localization dropdown clipping, cart count and wishlist route. */
(function () {
  'use strict';
  if (window.__hcGlobalHeaderFinalInstalled) return;
  window.__hcGlobalHeaderFinalInstalled = true;

  var postLoginStorageKey = 'hcB2bPostLoginTarget';
  var defaultCataloguePath = '/pages/wholesale-order';

  function rememberB2bLoginTarget(event) {
    var link = event.target && event.target.closest
      ? event.target.closest('[data-hc-b2b-login-target]')
      : null;
    if (!link) return;
    var target = link.getAttribute('data-hc-b2b-login-target') || defaultCataloguePath;
    if (target !== defaultCataloguePath) return;
    try { window.sessionStorage.setItem(postLoginStorageKey, target); } catch (error) {}
  }

  function resumeB2bLoginTarget() {
    var target = '';
    try { target = window.sessionStorage.getItem(postLoginStorageKey) || ''; } catch (error) {}
    if (target !== defaultCataloguePath) return false;
    try { window.sessionStorage.removeItem(postLoginStorageKey); } catch (error) {}
    if (window.location.pathname === target) return false;
    window.location.replace(target);
    return true;
  }

  document.addEventListener('click', rememberB2bLoginTarget, true);
  if (resumeB2bLoginTarget()) return;

  var style = document.createElement('style');
  style.id = 'hc-global-header-final-style';
  style.textContent = `
    @keyframes hcGlobalHeaderTicker {
      from { transform: translate3d(0, 0, 0); }
      to { transform: translate3d(-50%, 0, 0); }
    }

    @media (min-width: 1200px) {
      header.header-basic,
      header.header-basic .hc1440-master.hc-final-announcement-wrap,
      header.header-basic .hc1440-right,
      header.header-basic .hc1440-language,
      header.header-basic .hc1440-language .top-language-currency,
      header.header-basic .hc1440-language .halo-top-language,
      header.header-basic .hc1440-language .halo-top-currency {
        overflow: visible !important;
      }

      header.header-basic .hc1440-master.hc-final-announcement-wrap,
      header.header-basic .hc1440-right,
      header.header-basic .hc1440-language {
        z-index: 10000 !important;
      }

      header.header-basic .hc1440-ticker.hc-global-header-ticker {
        display: block !important;
        overflow: hidden !important;
        justify-content: flex-start !important;
        text-align: left !important;
      }

      header.header-basic .hc-global-header-ticker-track {
        display: flex !important;
        width: max-content !important;
        min-width: max-content !important;
        height: 40px !important;
        align-items: center !important;
        animation: hcGlobalHeaderTicker 22s linear infinite !important;
        will-change: transform !important;
      }

      header.header-basic .hc-global-header-ticker-copy {
        display: inline-flex !important;
        flex: 0 0 auto !important;
        height: 40px !important;
        padding-right: 62px !important;
        align-items: center !important;
        gap: 28px !important;
        white-space: nowrap !important;
      }

      header.header-basic .hc-global-header-ticker-copy a,
      header.header-basic .hc-global-header-ticker-copy .hc-global-header-dot {
        display: inline-flex !important;
        flex: 0 0 auto !important;
        height: 40px !important;
        align-items: center !important;
        line-height: 40px !important;
        white-space: nowrap !important;
      }

      header.header-basic .hc1440-language .dropdown-language,
      header.header-basic .hc1440-language .dropdown-currency {
        top: 40px !important;
        overflow: visible !important;
        z-index: 10020 !important;
      }
    }

    header.header-basic .header__icon--cart {
      position: relative !important;
      overflow: visible !important;
    }

    header.header-basic .header__icon--cart .cart-count-bubble {
      position: absolute !important;
      inset: 13px 0 0 0 !important;
      display: flex !important;
      width: 40px !important;
      height: 24px !important;
      min-width: 40px !important;
      min-height: 24px !important;
      align-items: center !important;
      justify-content: center !important;
      margin: 0 !important;
      padding: 0 !important;
      transform: none !important;
      background: transparent !important;
      pointer-events: none !important;
    }

    header.header-basic .header__icon--cart .cart-count-bubble .text {
      position: static !important;
      display: flex !important;
      width: 100% !important;
      height: 100% !important;
      align-items: center !important;
      justify-content: center !important;
      margin: 0 !important;
      padding: 0 !important;
      line-height: 1 !important;
      text-align: center !important;
    }
  `;
  document.head.appendChild(style);

  function headerLink(href, label) {
    return '<a href="' + href + '">' + label + '</a>';
  }

  function tickerCopy(hidden) {
    return '<span class="hc-global-header-ticker-copy"' + (hidden ? ' aria-hidden="true"' : '') + '>' +
      headerLink('/pages/wholesale-order', 'B2B SS27 ONLINE STORE') +
      '<span class="hc-global-header-dot" aria-hidden="true">·</span>' +
      headerLink('/collections/moonspellsss26', '30% OFF MOONSPELLS ’26') +
      '<span class="hc-global-header-dot" aria-hidden="true">·</span>' +
      headerLink('/pages/work-4-us', 'BECOME AN AMBASSADOR') +
    '</span>';
  }

  function applyHeaderRepair() {
    var ticker = document.querySelector('header .customer-service-text, header .hc1440-ticker');
    if (ticker && !ticker.querySelector('.hc-global-header-ticker-track')) {
      ticker.classList.add('hc1440-ticker', 'hc-global-header-ticker');
      ticker.innerHTML = '<span class="hc-global-header-ticker-track">' +
        tickerCopy(false) + tickerCopy(true) +
      '</span>';
    }

    var wishlist = document.querySelector('header a.header__icon--wishlist');
    if (wishlist && wishlist.getAttribute('href') !== '/pages/b2b-my-account') {
      wishlist.setAttribute('href', '/pages/b2b-my-account');
      wishlist.setAttribute('aria-label', 'Open B2B account hub');
      wishlist.setAttribute('title', 'B2B account hub');
    }
  }

  var scheduled = false;
  function scheduleRepair() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      applyHeaderRepair();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHeaderRepair, { once: true });
  } else {
    applyHeaderRepair();
  }

  var header = document.querySelector('header');
  if (header) {
    new MutationObserver(scheduleRepair).observe(header, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', scheduleRepair);
})();
